import React, { Component } from 'react';
import axios from 'axios';
import { Store } from 'react-notifications-component';
import { trackEvent, AnalyticsEvents } from '../../utils/analytics';

class NewsletterSubscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            submitting: false,
            subscribed: false
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        if (this.state.submitting || this.state.subscribed) {
            return;
        }

        const { email, name } = this.state;

        // Validation basique
        if (!email || !email.includes('@')) {
            Store.addNotification({
                title: 'Email invalide',
                message: 'Veuillez entrer une adresse email valide',
                type: 'warning',
                insert: 'top',
                container: 'top-right',
                dismiss: { duration: 3000 }
            });
            return;
        }

        this.setState({ submitting: true });

        try {
            const response = await axios.post('/api/newsletters/subscribe', {
                email: email.trim(),
                name: name.trim() || null
            });

            if (response.data.success) {
                this.setState({
                    subscribed: true,
                    submitting: false
                });

                trackEvent(AnalyticsEvents.NEWSLETTER_SUBSCRIBE);

                Store.addNotification({
                    title: 'Abonnement réussi !',
                    message: response.data.message || 'Merci pour votre abonnement !',
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    dismiss: { duration: 5000 }
                });
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            const message = error.response?.data?.message || 'Une erreur est survenue lors de l\'abonnement';

            Store.addNotification({
                title: 'Erreur',
                message: message,
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                dismiss: { duration: 5000 }
            });

            this.setState({ submitting: false });
        }
    };

    render() {
        const { email, submitting, subscribed } = this.state;
        const { variant = 'default' } = this.props;

        if (subscribed && variant === 'article') {
            return (
                <section className="article-newsletter-card article-newsletter-card--success">
                    <span className="article-newsletter-kicker">Newsletter</span>
                    <h2>Merci pour votre abonnement !</h2>
                    <p>Vous recevrez bientôt les prochains articles directement par email.</p>
                </section>
            );
        }

        if (subscribed) {
            return (
                <section className="newsletter-area section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <div className="section-title">
                                    <h2>Merci pour votre abonnement !</h2>
                                    <p>Vous recevrez bientôt nos dernières actualités par email.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        if (variant === 'article') {
            return (
                <section className="article-newsletter-card">
                    <div className="article-newsletter-content">
                        <span className="article-newsletter-kicker">Newsletter</span>
                        <h2>Recevoir les prochains articles</h2>
                        <p>Une sélection courte des nouveaux retours d'expérience, projets et veilles publiés sur le portfolio.</p>
                    </div>
                    <form onSubmit={this.handleSubmit} className="article-newsletter-form">
                        <input
                            type="email"
                            name="email"
                            className="article-newsletter-email-input"
                            placeholder="Votre adresse email"
                            value={email}
                            onChange={this.handleChange}
                            required
                            disabled={submitting}
                        />
                        <button
                            type="submit"
                            className="article-newsletter-submit-btn"
                            disabled={submitting}
                        >
                            {submitting ? 'Envoi...' : "S'abonner"}
                        </button>
                    </form>
                </section>
            );
        }

        if (variant === 'compact') {
            return (
                <section className="newsletter-area-compact section-gap">
                    <div className="container">
                        <div className="newsletter-compact-wrapper">
                            <div className="row align-items-center">
                                <div className="col-lg-5 newsletter-compact-illustration">
                                    <img className="img-fluid" src={require('../../img/newsletter-illustration.png')} alt="Newsletter" />
                                </div>
                                <div className="col-lg-7 newsletter-compact-content">
                                    <h2>Restez informé</h2>
                                    <p>Abonnez-vous à la newsletter pour recevoir les dernières actualités</p>
                                    <form onSubmit={this.handleSubmit} className="newsletter-form-compact">
                                        <div className="newsletter-compact-input-group">
                                            <input
                                                type="email"
                                                name="email"
                                                className="newsletter-compact-email-input"
                                                placeholder="Votre adresse email"
                                                value={email}
                                                onChange={this.handleChange}
                                                required
                                                disabled={submitting}
                                            />
                                            <button
                                                type="submit"
                                                className="newsletter-compact-submit-btn"
                                                disabled={submitting}
                                            >
                                                {submitting ? 'Envoi...' : "S'abonner"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <section className="newsletter-area-popup section-gap">
                <div className="container">
                    <div className="newsletter-popup-wrapper">
                        <div className="row align-items-center">
                            <div className="col-lg-6 newsletter-illustration-col">
                                <div className="newsletter-illustration">
                                    <img className="img-fluid" src={require('../../img/newsletter-illustration.png')} alt="Newsletter" />
                                </div>
                            </div>
                            <div className="col-lg-6 newsletter-content-col">
                                <div className="newsletter-content">
                                    <h2>Abonnez-vous à notre newsletter</h2>
                                    <p>
                                        Ne manquez aucune offre exclusive ! Abonnez-vous à notre newsletter pour recevoir
                                        des réductions et des offres spéciales directement dans votre boîte de réception.
                                    </p>
                                    <form onSubmit={this.handleSubmit} className="newsletter-form-popup">
                                        <div className="newsletter-input-group">
                                            <input
                                                type="email"
                                                name="email"
                                                className="newsletter-email-input"
                                                placeholder="Votre adresse email"
                                                value={email}
                                                onChange={this.handleChange}
                                                required
                                                disabled={submitting}
                                            />
                                            <button
                                                type="submit"
                                                className="newsletter-submit-btn"
                                                disabled={submitting}
                                            >
                                                {submitting ? 'Envoi...' : "S'abonner"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default NewsletterSubscribe;

